
  <script>
    import { onMount } from "svelte";
    import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
    import backend from "../../../../../server";
    import SelectGames from "../player/SelectGames.svelte";

    export let isStake = false; 
    let isAlet = false;
    let isSelectGames = false;
    let message='';
    let tipo = false; 

    
    let configBonnus = { games: [], players: [], client: { id: null } };
    
    let isLoading=false;
    let currencies = [
        { code: "USD", name: "US Dollar" },
        { code: "EUR", name: "Euro" },
        { code: "GBP", name: "British Pound" },
        { code: "JPY", name: "Japanese Yen" },
        { code: "AUD", name: "Australian Dollar" },
        { code: "CAD", name: "Canadian Dollar" },
        { code: "CHF", name: "Swiss Franc" },
        { code: "MXN", name: "Mexican Peso" },
        { code: "BRL", name: "Brazilian Real" },
        { code: "INR", name: "Indian Rupee" }
    ];
    let selectedGamesIds = [];
    let filterCriteria = {};
    let selectedCurrencies = [];
    let stakes = { siteCode: 'latinsport21', currencies: selectedCurrencies, games: selectedGamesIds };

  const handleGameRowClick = (id) => {
        if (selectedGamesIds.includes(id)) {
            selectedGamesIds = selectedGamesIds.filter(selectedId => selectedId !== id);
        } else {
            selectedGamesIds = [...selectedGamesIds, id];
        }
        stakes = { ...stakes, games: selectedGamesIds };
    };
    const handleCurrencyRowClick = (currencyCode) => {
        if (selectedCurrencies.includes(currencyCode)) {
            selectedCurrencies = selectedCurrencies.filter(code => code !== currencyCode);
        } else {
            selectedCurrencies = [...selectedCurrencies, currencyCode];
        }
        stakes = { ...stakes, currencies: selectedCurrencies };
    };
    const closeModal = () => {  isStake = false; isAlet=false };
    
 
    const saveSelectedGames = async () => {
    try {
        isLoading = true;
        let gamesWithoutSuffix = stakes.games.map(gameId => gameId.replace('_ptp', ''));
        const updatedStakes = {  ...stakes,  games: gamesWithoutSuffix };
        isAlet= true;
        let response = await backend.freespin.stakeGeneratorSave(updatedStakes);
         tipo = response.data.result ? true : false;
         message = tipo ? "Se guardó correctamente." : response.data?.error?.message || "Error desconocido.";

    } catch (error) {
        console.log('Error saving games:', error.message);
    } finally {
        isLoading = false;
    }
};

const selectGames = () => {
    isSelectGames = true;
  };
  function gamesExtraction(updatedConfig) {
    configBonnus = updatedConfig;
    isSelectGames = false;
    console.log("Games Recivied: ", configBonnus);
  }
</script>

<Modal isOpen={isStake} toggle={closeModal} size="lg">
    <ModalHeader toggle={closeModal}>
        Cancel Bonuses
    </ModalHeader>
    <ModalBody>
        <div class="credentials-section">
            <div class="table-container">
                <h5>Juegos:</h5> 
                <button
                  on:click={() => selectGames()}
                  class="btn btn-outline-secondary btn-sm"
                >
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> Nuevos
                </button>

                <table size="sm" class="table table-sm">
                    <thead class="table-dark">
                        <tr>
                            <th>#</th>
                            <th>Game ID</th>
                            <th>Name</th>
                            <th style="text-align: center;">Selected</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if isLoading}
                            <tr><td colspan="4" style="text-align: center;">Loading...</td></tr>
                        {:else if configBonnus.games.length === 0}
                            <tr><td colspan="4" style="text-align: center;">No games found</td></tr>
                        {:else}
                            {#each configBonnus.games as game, index}
                                <tr 
                                    on:click={() => handleGameRowClick(game.gameid)} 
                                    class:selected={selectedGamesIds.includes(game.gameid)}
                                    style="cursor: pointer;">
                                    <td>{index + 1}</td>
                                    <td>{game.gameid}</td>
                                    <td>{game.name}</td>
                                    <td style="text-align: center;">
                                        <span>{selectedGamesIds.includes(game.gameid) ? '✔️' : ''}</span>
                                    </td>
                                </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
            <h5>Monedas:</h5>
            <!-- Currencies Table -->
            <div class="table-container">
              
                <table size="sm" class="table table-sm">
                    <thead class="table-dark">
                        <tr>
                            <th>#</th>
                            <th>Code</th>
                            <th>Name</th>
                            <th style="text-align: center;">Selected</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each currencies as currency, index}
                            <tr 
                                on:click={() => handleCurrencyRowClick(currency.code)} 
                                class:selected={selectedCurrencies.includes(currency.code)}
                                style="cursor: pointer;">
                                <td>{index + 1}</td>
                                <td>{currency.code}</td>
                                <td>{currency.name}</td>
                                <td style="text-align: center;">
                                    <span>{selectedCurrencies.includes(currency.code) ? '✔️' : ''}</span>
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Site Selection -->
        <div class="row">
            <div class="col-md-12">
                <label for="force">Código del Sitio:</label>
                <input type="text" class="form-control"  bind:value={stakes.siteCode} disabled>

                {#if isAlet}
                <div class={`alert mt-2 alert-${tipo ? 'success' : 'danger'} alert-dismissible fade show`} role="alert">
                    <strong>{tipo ? '¡Éxito!' : '¡Error!'} {message}</strong>                   
                    <button type="button" class="btn-close" on:click={() => isAlet = false}></button>
                </div>
                {/if}
            </div>
            
           
        </div>
    </ModalBody>
    <ModalFooter>
        <button class="btn btn-primary" on:click={saveSelectedGames} disabled={isLoading}>
            {#if isLoading}
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
            {:else}
                Save
            {/if}
        </button>
    </ModalFooter>
</Modal>
{#if isSelectGames}
  <SelectGames {configBonnus} onSave={gamesExtraction} bind:isSelectGames />
{/if}

<style>
    .credentials-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    }
    .table-container {
    max-height: 300px;
    overflow-y: auto;
    }
    .selected {
    background-color: #dfefef; 
    }

 </style>